import { useState } from "react";
import Loader from "../../../Dashboard/components/Loader";
import useProductFamilies from "./hooks/useProductFamilies";
import ProductFamilyCard from "./ProductFamilyCard";
import { AccountProduct, ProductFamily } from "./types";
import UpsertAccountProductModal from "./UpsertAccountProductModal";
import DeleteAccountProductModal from "./DeleteAccountProductModal";

const AddOnsSupport = () => {
  const [deleteAccountProduct, setDeleteAccountProduct] = useState<AccountProduct>(null);
  const [upsertAccountProduct, setUpsertAccountProduct] = useState<{
    productFamily: ProductFamily;
    accountProduct?: Partial<AccountProduct>;
  }>(null);
  const { actions, loading, productFamilies } = useProductFamilies();

  return (
    <div>
      <h3>Add-Ons</h3>
      <div className="tw-relative tw-flex tw-justify-center tw-gap-[24px] tw-flex-wrap">
        {loading && <Loader />}
        {!loading && !productFamilies.length && <div>No Add-Ons available</div>}
        {productFamilies.map((productFamily) => (
          <ProductFamilyCard
            key={productFamily.id}
            onAddAccountProduct={setUpsertAccountProduct}
            onDeleteAccountProduct={setDeleteAccountProduct}
            productFamily={productFamily}
          />
        ))}
      </div>
      <UpsertAccountProductModal
        productFamily={upsertAccountProduct?.productFamily}
        accountProduct={upsertAccountProduct?.accountProduct}
        onClose={() => setUpsertAccountProduct(null)}
        onUpsertAccountProduct={(product) => {
          actions.upsertAccountProduct(product);
          setUpsertAccountProduct(null);
        }}
      />
      <DeleteAccountProductModal
        accountProduct={deleteAccountProduct}
        onClose={() => setDeleteAccountProduct(null)}
        onDelete={() => {
          actions.deleteAccountProduct(deleteAccountProduct);
          setDeleteAccountProduct(null);
        }}
      />
    </div>
  );
};
export default AddOnsSupport;
